// extracted by mini-css-extract-plugin
module.exports = {"paginationNavContainer":"style_paginationNavContainer__3ePgV","paginationNavButton":"style_paginationNavButton__AYBxr"};